export default __webpack_public_path__ + "static/media/Tralexho-Main-Banners-Technology.df74295c.png";